import jwtAuthAxios from "./auth/jwtAuth";

// API y MCP: los tokens personales del usuario, las aplicaciones conectadas por OAuth (Claude, ChatGPT…) y la pantalla
// de autorización de OAuth.
const apiAccessServices = {};

apiAccessServices.listTokens = async () => {
    const { data } = await jwtAuthAxios.get("/api_tokens");
    return data;
};

// write: además de leer y generar reportes, puede crear y editar dashboards y reglas de alerta.
apiAccessServices.createToken = async ({ name, expiresInDays, write = false }) => {
    const { data } = await jwtAuthAxios.post("/api_tokens", { name, expires_in_days: expiresInDays || null, write }, { silentErrors: true });
    return data;
};

apiAccessServices.revokeToken = async (id) => {
    await jwtAuthAxios.delete(`/api_tokens/${id}`);
};

apiAccessServices.listConnections = async () => {
    const { data } = await jwtAuthAxios.get("/oauth_connections");
    return data;
};

apiAccessServices.revokeConnection = async (id) => {
    await jwtAuthAxios.delete(`/oauth_connections/${id}`);
};

apiAccessServices.getAuthorization = async (params) => {
    const { data } = await jwtAuthAxios.get("/oauth_authorization", { params, silentErrors: true });
    return data;
};

apiAccessServices.answerAuthorization = async (params, approve, grantWrite = false) => {
    const { data } = await jwtAuthAxios.post("/oauth_authorization", { ...params, approve, grant_write: grantWrite }, { silentErrors: true });
    return data;
};

export default apiAccessServices;
